export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-01.796e1461.jpg";